// Pure Deviation evaluator for the Objectives page.
//
// "Deviation" here is the formal, Objective-based concept - distinct from Active groups' informal
// `needsAttention` heuristic (see that page's needsAttention.ts). A row (a Barn's
// own aggregate figure, or a Section beneath an expanded Barn) is in Deviation once its measured
// mortality exceeds its own resolved target. Either side being unknown means the comparison can't be
// made and is not a deviation.
//
// Pure, no Vue/store dependencies, so it is unit-testable in isolation the day a runner lands.

export type DeviationValues = {
    currentValue: number | null;
    resolvedTarget: number | null;
};

export function isInDeviation(row: DeviationValues): boolean {
    return row.currentValue != null && row.resolvedTarget != null && row.currentValue > row.resolvedTarget;
}

// Mirror of isInDeviation for the "doing fine" case — both sides known, and not in Deviation. A row
// with no resolved target (no Farm/Directory Objective set) is neither: it stays uncoloured rather
// than reading as false reassurance.
export function isWithinTarget(row: DeviationValues): boolean {
    return row.currentValue != null && row.resolvedTarget != null && !isInDeviation(row);
}

// How many of a Barn's Sections are in Deviation — drives the collapsed-Barn red count badge.
// Barn-level only - the badge is an "expand me, something's wrong underneath" affordance, and a Farm
// has nothing to expand, only Barns with Sections do.
export function countDeviatingSections(sections: DeviationValues[]): number {
    return sections.filter(isInDeviation).length;
}
